// extracted by mini-css-extract-plugin
export var fadeIn = "_89-0";
export var panelInner = "_89-2";
export var panelOuter = "_89-1";